import React from "react";

import {
  Button,
  ButtonVariant,
  Flex,
  FlexItem,
  Tooltip,
} from "@patternfly/react-core";

import { socialsService } from "../services/socialsService";
import { ICON_SIZES } from "../../../../../../shared/constants/logoSizes";
import { ICON_BOXES } from "../../../../../../shared/constants/iconSizes";
import useAppearance from "shared/appearance/hooks/useAppearance";

const SchoolHeaderSocials = ({ variant = "desktop", forceColorScheme = null }) => {
  // const { colorScheme } = useAppearance();
  
  // const socials = socialsService.getSocials(variant, colorScheme);
  const { colorScheme } = useAppearance();

  const scheme = forceColorScheme ?? colorScheme;

  const socials = socialsService.getSocials(variant, scheme);
  if (!socials.length) {
    return null;
  }

  return (
    <Flex
      alignItems={{ default: "alignItemsCenter" }}
      spaceItems={{ default: "spaceItemsSm" }}
      flexWrap={{ default: "nowrap" }}
    >
      {socials.map((social) => {
        const iconBox = ICON_BOXES[social.icon?.size ?? "md"];
        let content = null;

        if (social.icon?.component) {
          content = React.cloneElement(social.icon.component, {
            style: {
              fontSize: "1.5rem",
              display: "block",
              ...(social.icon.offset && {
                transform: `translate(${social.icon.offset.x}px, ${social.icon.offset.y}px)`,
              }),
            },
          });
        }

        if (social.image?.src) {
          content = (
            <img
              src={social.image.src}
              alt={social.label}
              loading="lazy"
              style={{
                height: `${
                  social.image.height ??
                  // ICON_SIZES[social.image.size]
                  ICON_SIZES[variant][social.image.size]
                }px`,
                width: "auto",
                display: "block",
                ...(social.image.offset && {
                  transform: `translate(${social.image.offset.x}px, ${social.image.offset.y}px)`,
                }),
              }}
            />
          );
        }

        if (!content) {
          return null;
        }

        const iconWrapper = (
          <span
            style={{
              width: `${iconBox.width}px`,
              height: `${iconBox.height}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {content}
          </span>
        );
        const wrappedContent = social.tooltip ? (
          <Tooltip content={social.tooltip}>
              {iconWrapper}
          </Tooltip>
        ) : (
          iconWrapper
        );

        return (
          <FlexItem key={social.id}>
            <Button
              component="a"
              variant={ButtonVariant.plain}
              href={social.href}
              target={social.external ? "_blank" : undefined}
              rel={social.external ? "noopener noreferrer" : undefined}
              aria-label={social.label}
              isInline
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              {wrappedContent}
            </Button>
          </FlexItem>
        );
      })}
    </Flex>
  );
};

export default SchoolHeaderSocials;